import { Controller } from '@hotwired/stimulus'

const IFRAME_ALLOW = [
  'camera *',
  'microphone *',
  'geolocation *',
  'clipboard-read *',
  'clipboard-write *',
  'gyroscope *',
  'accelerometer *',
  'magnetometer *',
  'ch-ua-platform-version *',
  'ch-ua-model *',
  'ch-ua-full-version *',
].join('; ')

export default class extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String,
    sidebarMenuEnabled: Boolean,
    personalFieldsReadonly: Boolean,
    welcomePageEnabled: Boolean,
  };

  connect() {
    this.syncModal = new bootstrap.Modal(
      document.getElementById('syncModal'),
      { backdrop: 'static', keyboard: false }
    )

    this.initWidget()
  }

  disconnect() {
    this.iframeObserver?.disconnect()
  }

  initWidget() {
    this.observeIframeInsertion()

    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: 'fr',
        isSidebarMenuEnabled: this.hasSidebarMenuEnabledValue ? this.sidebarMenuEnabledValue : true,
        arePersonalFieldsReadonly: this.hasPersonalFieldsReadonlyValue ? this.personalFieldsReadonlyValue : false,
        isWelcomePageEnabled: this.hasWelcomePageEnabledValue ? this.welcomePageEnabledValue : true,

        onMyAccount: () => this.redirectToNextStep(false, 4000),
        onFinish: () => this.redirectToNextStep(true, 0),
        onPageChange: () => {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }
    )
  }

  observeIframeInsertion() {
    this.iframeObserver = new MutationObserver(() => {
      const iframe = this.element.querySelector('iframe')
      if (!iframe) return

      this.iframeObserver.disconnect()
      iframe.setAttribute('allow', IFRAME_ALLOW)
      iframe.setAttribute('src', iframe.getAttribute('src'))
    })
    this.iframeObserver.observe(this.element, { childList: true, subtree: true })
  }

  redirectToNextStep(success = false, delay = 0) {
    const url = new URL(this.redirectUrlValue)
    if (success) url.searchParams.set('status', 'success')
    if (delay > 0) this.syncModal.show()
    setTimeout(() => { window.location.replace(url) }, delay)
  }
}
